import type { ISpread } from "../../spreadsSlice";

export const choicePathSpread: ISpread = {
  id: "spread_choice_path",
  name: "Путь выбора",
  altNames: ["Path of Decision Spread"],
  purpose:
    "Анализ сложной ситуации с двумя вариантами действий, понимание последствий, ресурсов и уроков каждого пути.",
  cardsCount: 7,
  layout: `      [2]   [3]
        [4]   [5]
        [6]   [7]
          [1]`,
  positions: [
    {
      id: "situation",
      title: "Суть ситуации",
      meaning: "Основная энергия происходящего и исходная точка выбора.",
    },
    {
      id: "path_a",
      title: "Путь A",
      meaning: "Куда ведёт первый вариант.",
    },
    {
      id: "path_b",
      title: "Путь B",
      meaning: "Куда ведёт второй вариант.",
    },
    {
      id: "support_a",
      title: "Что поддерживает путь A",
      meaning: "Ресурс или мотив первого пути.",
    },
    {
      id: "support_b",
      title: "Что поддерживает путь B",
      meaning: "Ресурс или мотив второго пути.",
    },
    {
      id: "lesson_a",
      title: "Чему учит путь A",
      meaning: "Глубинный смысл и духовный урок первого пути.",
    },
    {
      id: "lesson_b",
      title: "Чему учит путь B",
      meaning: "Глубинный смысл и духовный урок второго пути.",
    },
  ],
  symbolism:
    "Карта ситуации является центральной точкой выбора; пары пути и поддержки показывают потенциал каждого направления, а две последние позиции раскрывают глубинный урок каждого решения.",
  archetypes: ["Выбор", "Два пути", "Урок опыта"],
  psychology:
    "Помогает увидеть, что ни один выбор не является автоматически правильным или неправильным и что каждый возможный путь связан с собственным опытом и уроком.",
  procedure: {
    preparation:
      "Сформулировать вопрос в форме: «Что будет, если я выберу A или B?»",
    steps:
      "Перетасовать карты; сначала выложить карту ситуации, затем карты двух путей и их ресурсов, в конце — уроки; читать первый путь как 2–4–6, второй как 3–5–7, затем сопоставить их.",
  },
  interpretations: [
    "Луна в позиции ситуации может показывать неопределённость.",
    "Сила на пути A может указывать на необходимость преодоления.",
    "Шут на пути B может показывать новое начало.",
    "Справедливость и Звезда в уроках раскрывают разные глубинные задачи двух решений.",
  ],
  nuances: [
    "Не оценивать пути исключительно как «лучше» и «хуже».",
    "Урок каждого пути может быть важнее внешнего результата.",
    "Если оба пути выглядят тяжёлыми, стоит рассмотреть возможность третьего варианта.",
  ],
  examples: [
    {
      cards: [
        "Луна",
        "Сила",
        "Шут",
        "Императрица",
        "Маг",
        "Справедливость",
        "Звезда",
      ],
      interpretation:
        "Исходная ситуация неясна; путь A связан с преодолением и поддержкой, путь B — с новым началом и активным проявлением, а их уроки раскрывают баланс и надежду.",
    },
  ],
  selfQuestions: [
    "Какой урок несёт каждый выбор?",
    "Чего я больше всего боюсь потерять?",
    "Какой путь созвучен моим настоящим ценностям?",
  ],
};

